import React from "react"
import { getMonth, getYear } from "date-fns"
import { CalendarNavigation } from "./CalendarNavigation"
import CalendarHeaderTitle from "./CalendarHeaderTitle"
import useShortMonths from "../hooks/useShortMonths"
import { CalendarCustomHeaderProps } from "../MultiRangeCalendar.domain"

const CalendarCustomHeader = (props: CalendarCustomHeaderProps) => {
	const { customHeaderCount, monthDate, ...rest } = props
	const isFirstCalendarMonth = customHeaderCount === 0

	const shortMonths = useShortMonths()
	const shortMonth = shortMonths[getMonth(monthDate)]
	const currentYear = getYear(monthDate)
	const title = `${shortMonth} ${currentYear}`

	return (
		<>
			{isFirstCalendarMonth && (
				<CalendarNavigation monthDate={monthDate} {...rest} />
			)}
			<CalendarHeaderTitle title={title} />
		</>
	)
}

export default CalendarCustomHeader
